export default __webpack_public_path__ + "img/custom-software-development.b2b028e2.png";